import "@anuncia/design-system/tokens.css";
import "./styles.css";

const app = document.querySelector<HTMLElement>("#app");

if (!app) {
  throw new Error("Missing #app root element");
}

const path = window.location.pathname.replace(/\/+$/, "") || "/";

if (path === "/admin" || path.startsWith("/admin/")) {
  void import("./admin/wizard").then(({ renderAdmin }) => renderAdmin(app));
} else if (path.startsWith("/p/")) {
  void import("./property-page").then(({ renderPropertyPage }) => renderPropertyPage(app, path));
} else if (path.startsWith("/c/")) {
  void import("./collection-page").then(({ renderCollectionPage }) =>
    renderCollectionPage(app, path),
  );
} else if (path.startsWith("/agente/")) {
  void import("./agent-profile").then(({ renderAgentProfilePage }) =>
    renderAgentProfilePage(app, path),
  );
} else if (path === "/perfil/editar") {
  void import("./magic-link-editor").then(({ renderMagicLinkEditor }) =>
    renderMagicLinkEditor(app),
  );
} else {
  void import("./landing").then(({ renderLanding }) => {
    renderLanding(app);
  });
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js"));
}
